/**
 * @jest-environment jsdom
 */
import {createSelector} from 'reselect';
import {initialState} from './reducer';

const selectState = (state) => state.TRACKING || initialState;

const selectOpenedAccordionOfferId = () =>
    createSelector(
        selectState,
        state => state.openedAccordionOfferId,
    );
const selectAlreadyTrackedAccordion = () =>
    createSelector(
        selectState,
        state => state.alreadyTrackedAccordion,
    );
const selectAlreadyTrackedAppliedFilter = () =>
    createSelector(
        selectState,
        state => state.alreadyTrackedAppliedFilter,
    );
const selectHotlineNumber = () =>
    createSelector(
        selectState,
        state => state.hotlineNumber,
    );

export {
    selectHotlineNumber,
    selectOpenedAccordionOfferId,
    selectAlreadyTrackedAccordion,
    selectAlreadyTrackedAppliedFilter,
};
